// extracted by mini-css-extract-plugin
export default {"bonusAndPolls":"earnedPoints_bonusAndPolls__1Lit0","container":"earnedPoints_container__uacRG","pointsAndResults":"earnedPoints_pointsAndResults__tsBpw"};